<section #mainContainer>
    <app-header></app-header>
    <article>
      <router-outlet></router-outlet>
    </article>
    <app-footer></app-footer>
</section>
